// extracted by mini-css-extract-plugin
module.exports = {"formSelectMenu":"FormComponent_formSelectMenu__ahwSJ","form":"FormComponent_form__PJuzm"};